import { forwardRef } from 'react';
import { Input as AntInput } from 'antd';
import type { TextAreaProps } from 'antd/es/input';
import type { TextAreaRef } from 'antd/es/input/TextArea';

import { cn } from '../../lib/cn';

/** Ô nhập nhiều dòng (§9.3.2). Dùng `autoSize` của antd khi cần tự giãn. */
export const Textarea = forwardRef<TextAreaRef, TextAreaProps>(function Textarea(
  { className, ...props },
  ref,
) {
  return <AntInput.TextArea ref={ref} className={cn(className)} {...props} />;
});
